import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "py-10 bg-h-primary-50" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col gap-5 mt-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_General = _resolveComponent("General")!
  const _component_Map = _resolveComponent("Map")!
  const _component_Quiz = _resolveComponent("Quiz")!
  const _component_AttentionLogs = _resolveComponent("AttentionLogs")!
  const _component_GridLayout = _resolveComponent("GridLayout")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_GridLayout, {
        list: _ctx.setlist(),
        banner: _ctx.banner,
        onOnScroll: _ctx.scrollMeTo
      }, {
        content: _withCtx(() => [
          (_ctx.loader)
            ? (_openBlock(), _createBlock(_component_Loader, {
                key: 0,
                loader: _ctx.loader
              }, null, 8, ["loader"]))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              ref: _ctx.enumLinks.general
            }, [
              _createVNode(_component_General, {
                courseId: _ctx.courseId,
                studentId: _ctx.studentId
              }, null, 8, ["courseId", "studentId"])
            ], 512),
            (_ctx.isAdaptive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  ref: _ctx.enumLinks.map,
                  class: "mt-3"
                }, [
                  _createVNode(_component_Map, {
                    courseId: _ctx.courseId,
                    studentId: _ctx.studentId,
                    type: 'STATS_LEARNING_MAP'
                  }, null, 8, ["courseId", "studentId"])
                ], 512))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              ref: _ctx.enumLinks.quiz
            }, [
              _createVNode(_component_Quiz, {
                courseId: _ctx.courseId,
                studentId: _ctx.studentId
              }, null, 8, ["courseId", "studentId"])
            ], 512),
            (_ctx.isAdaptive)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  ref: _ctx.enumLinks.attentionLogs
                }, [
                  _createVNode(_component_AttentionLogs, {
                    courseId: _ctx.courseId,
                    studentId: _ctx.studentId
                  }, null, 8, ["courseId", "studentId"])
                ], 512))
              : _createCommentVNode("", true)
          ], 512), [
            [_vShow, !_ctx.loader]
          ])
        ]),
        _: 1
      }, 8, ["list", "banner", "onOnScroll"])
    ])
  ]))
}